import { Banner } from '#components/atoms/banner/Banner.tsx';
import { Button } from '#components/atoms/buttons/Button.tsx';
import { Tooltip } from '#components/atoms/tooltip/Tooltip.tsx';

type Props = {
  onRequestDelete: () => void;
  /**
   * When set, the Delete button is disabled and this message is shown in a tooltip explaining why
   * (e.g. the organization is on a paid plan and must downgrade before it can be deleted).
   */
  disabledReason?: string;
};

export function DeleteAccountBanner({ onRequestDelete, disabledReason }: Props) {
  return (
    <Banner variant="alert" className="flex justify-between align-center">
      <div className="mr-16">
        <h3 className="h5 mt-0 mb-4">Delete organization</h3>
        <p className="p-md mb-0">Deleting your organization is permanent and cannot be undone.</p>
      </div>
      {disabledReason ?
        // A native disabled <button> swallows its own hover events, so the Tooltip wraps it in an
        // anchor element that still receives hover (same pattern as the "delete admin" menu item).
        <Tooltip content={disabledReason}>
          <Button variant="danger" disabled>
            Delete
          </Button>
        </Tooltip>
      : <Button variant="danger" onClick={onRequestDelete}>
          Delete
        </Button>
      }
    </Banner>
  );
}
